import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sharePostMail",
  "use": "sharePostMail-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"sharePostMail\"><circle cx=\"16\" cy=\"16\" fill=\"#f6efeb\" r=\"15.5\" /><path d=\"m21.5 11h-11c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2zm0 1h.2l-5.7 4.4-5.7-4.4h.2zm1 7c0 .6-.4 1-1 1h-11c-.6 0-1-.4-1-1v-6c0-.1 0-.2.1-.3l6.4 4.9 6.4-4.9c.1.1.1.2.1.3z\" fill=\"#9c7446\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol